import { createApp } from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";

createApp(App)
  .use(router, VueMeta)
  .mount("#app");
